import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=f24f5ea6"
import script from "./TasksView.vue?vue&type=script&lang=ts"
export * from "./TasksView.vue?vue&type=script&lang=ts"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=f24f5ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports